import { Divider } from '@mui/material';
import { useRegion } from 'common/hooks/region';
import { PageHeader } from 'layouts/Generic/page-header';
import React from 'react';
import Form from './components/Form';

const NotificationSettings: React.FC = () => {
  const region = useRegion();
  return (
    <div className="flex flex-col space-y-8 px-8 py-12">
      <PageHeader title={`Notifications for ${region.name}`} />
      <Divider />
      <Form />
    </div>
  );
};
NotificationSettings.displayName = 'NotificationSettings';

export default NotificationSettings;
